// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LazyImageStyle } from "@insite/mobius/LazyImage";
import { aboutBlockStyles } from "@steiner/App/Widgets/AboutBlock/AboutBlock";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

aboutBlockStyles.container = {
    css: css`
        ${({
            backgroundColor,
            contentPosition,
            wrapperPaddingOnLargeScreen,
            wrapperPaddingOnSmallScreen,
            gapBetweenOnLargeScreen,
            gapBetweenOnSmallScreen,
        }: any) => {
            return css`
                display: flex;
                flex-direction: ${contentPosition};
                gap: ${gapBetweenOnLargeScreen};
                padding: ${wrapperPaddingOnLargeScreen};
                background: ${backgroundColor};

                ${xScreen("lte", "md")} {
                    flex-direction: ${contentPosition === "row" ? "column" : "column-reverse"};
                    gap: ${gapBetweenOnSmallScreen};
                    padding: ${wrapperPaddingOnSmallScreen};
                }
            `;
        }}
    `,
};

aboutBlockStyles.sourceWrapper = {
    css: css`
        width: 100%;
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;

        ${LazyImageStyle} {
            img {
                aspect-ratio: 1.58;
            }
        }
    `,
};

aboutBlockStyles.contentWrapper = {
    css: css`
        ${({ contentPaddingOnLargeScreen, contentPaddingOnSmallScreen, contentPaddingOnWideScreen }: any) => {
            return css`
                width: 100%;
                padding: ${contentPaddingOnLargeScreen};
                display: flex;
                flex: 1;
                flex-direction: column;
                justify-content: center;

                ${xScreen("lte", "md")} {
                    padding: ${contentPaddingOnSmallScreen};
                }

                ${xScreen("gte", "xl")} {
                    padding: ${contentPaddingOnWideScreen};
                }
            `;
        }}
    `,
};

aboutBlockStyles.buttonWrapper = {
    css: css`
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
    `,
};
